import {useState} from 'react';
import {Radio, RadioGroup} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../i18n/translations';
import {CompactModal} from '../../../modal/compact-modal';
import {useModalBtns} from '../../../modal/use-modal-btns';
import {UpdateScope} from '../../../../backend/interfaces/care-service';
import {RadioLabel} from '../../../shared/forms/radio';

export type CareServicesRepetitionsModalProps = {
  mode: 'delete' | 'edit';
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (option: UpdateScope) => Promise<void>;
};

export function CareServicesRepetitionsModal(props: CareServicesRepetitionsModalProps) {
  const [value, setValue] = useState<UpdateScope>('only-this-instance');
  const {t} = useTranslation();

  const actionBtns = useModalBtns({
    left: {
      type: 'cancel',
      onClick: props.onCancel,
      disabled: props.loading,
    },
    right: {
      type: props.mode === 'delete' ? 'delete' : 'save',
      onClick: () => {
        return props.onConfirm(value);
      },
      loading: props.loading,
      disabled: props.loading,
    },
  });

  return (
    <CompactModal
      open
      title={
        props.mode === 'delete'
          ? t(translations.care_services.modals.delete_recurrent.title)
          : t(translations.care_services.modals.edit_recurrent.title)
      }
      actions={actionBtns}
      onClose={props.onCancel}
      PaperProps={{sx: {maxWidth: '500px'}}}
      className="care-service-repetition-modal"
    >
      <RadioGroup
        className="radio-group"
        aria-labelledby="radio-delete-group"
        name="radio-delete-group"
        onChange={(evt) => setValue(evt.target.value as UpdateScope)}
        value={value}
      >
        <RadioLabel
          label={t(translations.care_services.modals.repetition_options.only_this_event)}
          value={'only-this-instance' satisfies UpdateScope}
          checked={value === 'only-this-instance'}
          control={<Radio size="small" />}
        />
        <RadioLabel
          label={t(translations.care_services.modals.repetition_options.this_and_following)}
          value={'this-and-future-instances' satisfies UpdateScope}
          checked={value === 'this-and-future-instances'}
          control={<Radio size="small" />}
        />
      </RadioGroup>
    </CompactModal>
  );
}
